import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bde9f04")

_pushScopeId("data-v-1bde9f04")
const _hoisted_1 = { class: "_profileImage" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["_image", !_ctx.localSrc ? 'defaultBg' : ''],
      style: 'background-image: url(\'' + _ctx.getImage + '\');'
    }, null, 6)
  ]))
})